import apis from "../common/apis";
import { HTTP_METHOD_GET } from "../utils/constant";
import { callApi } from "./fetchTools";

export default {
  getSection: (id: string) => {
    return callApi(HTTP_METHOD_GET, `${apis.section}${id}`, null);
  },
  getSections: (ids: any) => {
    return callApi(HTTP_METHOD_GET, `${apis.sections}`, ids);
  },
};
